import '../styles/ApiDocsPage.css';
import { PageTitle } from '../components/PageTitle';
import { IconMail, IconRefresh, IconTrash, IconEye } from '@tabler/icons-react';

export function ApiDocsPage() {
  const endpoints = [
  {
    method: 'GET',
    path: '/emails/compact?address={email}',
    description: 'Get all emails (compact view) for a given address.',
    icon: <IconMail size={20} />,
  },
  {
    method: 'GET',
    path: '/emails?address={email}',
    description: 'Get all emails in full HTML format for a given address.',
    icon: <IconMail size={20} />,
  },
  {
    method: 'GET',
    path: '/emails/details/{id}',
    description: 'Get full plain-text content of an email by ID.',
    icon: <IconEye size={20} />,
  },
  {
    method: 'GET',
    path: '/emails/details/by-subject?address={email}&subject={subject}',
    description: 'Get plain-text email content by subject (with fuzzy match).',
    icon: <IconEye size={20} />,
  },
  {
    method: 'GET',
    path: '/emails/details/last?address={email}',
    description: 'Get the most recent email (plain-text format) for an address.',
    icon: <IconEye size={20} />,
  },
  {
    method: 'GET',
    path: '/emails/count?address={email}',
    description: 'Get total number of emails for an address.',
    icon: <IconRefresh size={20} />,
  },
  {
    method: 'DELETE',
    path: '/emails/{id}',
    description: 'Delete a specific email by ID.',
    icon: <IconTrash size={20} />,
  },
  {
    method: 'DELETE',
    path: '/emails?address={email}',
    description: 'Delete all emails for the given address.',
    icon: <IconTrash size={20} />,
  },
];


  return (
    <>
      <PageTitle title="Ephemail API Reference" />
      <div className="api-docs">
        <div className="api-base-url">
          <div className="base-url-icon">🌐</div>
          <div className="base-url-label">Base URL</div>
          <code className="base-url-code">https://api.ephemail.autos</code>
        </div>

        {endpoints.map((ep, idx) => (
          <div className="api-box" key={idx}>
            <div className={`api-method ${ep.method.toLowerCase()}`}>{ep.method}</div>
            <div className="api-info">
              <div className="api-path">{ep.icon} <code>{ep.path}</code></div>
              <div className="api-desc">{ep.description}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
